import React from 'react';

import {ContentListProps} from 'presentation/components/StyledCard/types';
import {TELEMEDICINE_INFO} from 'presentation/pages/private/booking/constants';
import {formatText} from 'presentation/utils';

import {BookingTypeEnum} from 'presentation/modules/booking/shared/constants/bookingTypeEnum';
import {BuildContentListParams} from './types';
import {AppointmentTeleTutorial} from '../../components/AppointmentTeleTutorial';

export function buildContentList({
	palette,
	colors,
	appointment,
	bookingType,
}: BuildContentListParams): ContentListProps[] {
	const isTelehealth = appointment.bookingType === BookingTypeEnum.TELEHEALTH;
	return [
		{
			iconName: 'medical-services-filled',
			iconColor: palette.primary.main,
			primaryText: formatText(appointment?.specialtyName),
			primaryTextFontSize: '0.875rem',
			primaryTextLineHeight: '1.25rem',
			secondaryText: bookingType,
			secondaryTextColor: colors.light.text.secondary,
			secondaryTextFontSize: '0.75rem',
			secondaryTextLineHeight: '1.125rem',
			customTypographyGap: '0px',
		},
		{
			iconName: 'doctor-filled',
			iconColor: palette.primary.main,
			primaryText: formatText(appointment?.providerName),
			primaryTextFontSize: '0.875rem',
			primaryTextLineHeight: '1.25rem',
			alignItems: 'center',
		},
		{
			iconName: 'location-on-filled',
			iconColor: palette.primary.main,
			primaryText: isTelehealth
				? formatText(TELEMEDICINE_INFO.name)
				: formatText(appointment?.clinicName),
			primaryTextFontSize: '0.875rem',
			primaryTextLineHeight: '1.25rem',
			secondaryText: isTelehealth ? <AppointmentTeleTutorial /> : undefined,
			secondaryTextLineHeight: '1rem',
			alignItems: isTelehealth ? 'flex-start' : 'center',
			customTypographyGap: '0px',
		},
	];
}
